// src/services/api.js
import axios from "axios";

export const baseURL = process.env.REACT_APP_BACKEND_API_URL;
// Create an Axios instance

export const APIPath = axios.create({
    baseURL: baseURL, // Replace with REACT_APP_API_URL for env support
    headers: {
        "Content-Type": "application/json",
    },
});
// Add interceptor to include token from sessionStorage
APIPath.interceptors.request.use((config) => {
    const storedToken = sessionStorage.getItem("keycloak_access_token");

    if (storedToken) {
        config.headers.Authorization = `Bearer ${storedToken}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});
